var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscriptionNavbarMobileLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 39,
    viewBox: "0 0 30 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5596 1.24744C29.0886 0.52578 28.29 0.0618565 27.4197 0H27.307L8.85672 0.0206188C7.69974 0.0206188 6.65538 0.752587 6.2663 1.83508L4.2595 7.38154C3.96257 8.19598 4.0752 9.10321 4.54619 9.82487C5.01717 10.5465 5.8158 11.0105 6.68609 11.0723H8.73385L0.163979 34.6912C-0.132947 35.5056 -0.0203201 36.4128 0.450665 37.1345C0.92165 37.8562 1.72028 38.3201 2.58034 38.3819H9.52224C10.6792 38.3819 11.7236 37.65 12.1127 36.5675L21.3685 11.0517H25.2388C26.3958 11.0517 27.4401 10.3094 27.8292 9.22692L29.836 3.68046C30.1329 2.86602 30.0203 1.95879 29.5493 1.23713L29.5596 1.24744Z",
    fill: "#101010"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.32356 8.11313H10.46C10.8696 8.11313 11.146 8.5152 11.0129 8.88633L1.67515 34.6392C1.53181 35.0207 1.81849 35.4228 2.22804 35.4228H8.98565C9.23138 35.4125 9.45664 35.2578 9.53855 35.031L19.1733 8.47396C19.2552 8.24715 19.4804 8.09251 19.7262 8.09251H24.7125C24.9582 8.09251 25.1834 7.93787 25.2653 7.70075L27.2722 2.15429C27.4155 1.77284 27.1288 1.37077 26.7193 1.37077L8.34061 1.39139C8.09488 1.39139 7.86962 1.54603 7.78771 1.77284L5.78091 7.3193C5.63757 7.70075 5.92425 8.10282 6.3338 8.10282L6.32356 8.11313Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionNavbarMobileLogo);
export default __webpack_public_path__ + "static/media/subscription-navbar-mobile-logo.c2ad57c2419c07a98afbb1183a4f4f09.svg";
export { ForwardRef as ReactComponent };